module.exports = new __parcel__URL__("crash_12.4ad8210f.mp3").toString();